import type { AssetEntry } from './assetPayload';

/**
 * The SKU of the configured product, built from the article numbers of the
 * single choices: `A-B-C-D`.
 *
 * Same rule as the Magento plugin used for the cart item's SKU
 * (Model/Product/Option/Type/Configento.php:getOptionSku): per
 * Characteristic, in Component order, the chosen Value's SKU — for a multi
 * pick the first non-empty one — else the Characteristic's own SKU; empty
 * parts are skipped and the parts are joined with `-`. One deliberate
 * difference: a Characteristic a rule has removed contributes nothing — it
 * is not part of the order.
 *
 * {@link buildAssetPayload} calls this with the entries it keeps, and every
 * consumer reads the result from `_combined_sku`.
 */
export function joinCombinedSku(entries: Iterable<AssetEntry>): string {
    let sku = '';
    for (const entry of entries) {
        const part = entryPart(entry);
        if (part === '') continue;
        if (sku !== '' && !sku.endsWith('-')) sku += '-';
        sku += part;
    }
    return sku;
}

function entryPart(entry: AssetEntry): string {
    let choice = entry.choiceSku;
    if (Array.isArray(choice)) choice = choice.find((s) => typeof s === 'string' && s !== '');
    if (typeof choice === 'string' && choice !== '') return choice;
    return typeof entry.sku === 'string' ? entry.sku.trim() : '';
}
